import React from 'react';
import { UploadRequest } from './UserFileUploadInput';
import './uploadingFile.module.scss';
import { DescriptionOutlined } from '@material-ui/icons';
import { ByteUtils } from '../../../../commonv3/utils/bytes';

type Props = {
  request: UploadRequest;
};

export const UploadingFileSummary = ({ request }: Props) => {
  const progress = `${Math.ceil(request.progress * 100)}%`;
  return (
    <div styleName="uploading-file-summary">
      <div styleName="file-summary-wrapper">
        <DescriptionOutlined styleName="file-icon" />
        <div styleName="file-summary">
          <div styleName="file-name">{request.file.name}</div>
          <div styleName="file-size">{ByteUtils.formatBytes(request.file.size)}</div>
        </div>
      </div>
      <div styleName="progress-bar">
        <div styleName="progress" style={{ width: progress }} />
      </div>
    </div>
  );
};
